//@ts-ignore
import '@mantine/core/styles.css';
//@ts-ignore
import '@mantine/notifications/styles.css';
//@ts-ignore
import '@mantine/spotlight/styles.css';
//@ts-ignore
import '@mantine/charts/styles.css';
import '@/theme/global.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { MotionConfig } from 'framer-motion';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/it';

import App from '@/app/App';
import DashboardAuthProvider from '@/lib/beauth/beauth.provider';
import authLinkBoot from '@/lib/beauth/auth.link.boot';
import NotificationsHost from '@/app/Notifications.Host';
import { persistor, store } from '@/store/store';
import { cssVariablesResolver, theme } from '@/theme/theme';

dayjs.extend(relativeTime);
dayjs.locale('it');

authLinkBoot();

const container = document.getElementById('root') as HTMLElement;

if (window.location.pathname === '/print') {
    void import('@/app/print/Print.Root').then(({ mountPrint }) => mountPrint(container));
} else ReactDOM.createRoot(container).render(
    <React.StrictMode>
        <MantineProvider theme={theme} defaultColorScheme="dark" cssVariablesResolver={cssVariablesResolver}>
            <MotionConfig reducedMotion="user">
                <NotificationsHost />
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <DashboardAuthProvider>
                            <ModalsProvider>
                                <App />
                            </ModalsProvider>
                        </DashboardAuthProvider>
                    </PersistGate>
                </Provider>
            </MotionConfig>
        </MantineProvider>
    </React.StrictMode>
);